import { IconBase, type IconProps } from './IconBase';

/**
 * BolsaIcon — bolso de mano (handbag).
 *
 * Simbolo: tienda, encargo, producto artesanal.
 *
 * Composicion:
 * - Asa: arco superior semicircular que sale por los bordes superiores
 *   del cuerpo, sin tocar el techo del viewBox para mantener aire.
 * - Cuerpo: rectangulo con esquinas redondeadas (la base del bolso).
 * - Detalle de cierre: pequena linea horizontal centrada en el techo
 *   del cuerpo, sugiriendo costura/cierre.
 */
export function BolsaIcon(props: IconProps) {
  return (
    <IconBase {...props}>
      {/* Asa */}
      <path d="M8 9 V 7 A 4 4 0 0 1 16 7 V 9" />
      {/* Cuerpo del bolso */}
      <path d="M4.5 9.5 H 19.5 L 18.5 20 A 1.5 1.5 0 0 1 17 21.5 H 7 A 1.5 1.5 0 0 1 5.5 20 Z" />
      {/* Detalle de cierre superior */}
      <path d="M10.5 12.5 H 13.5" />
    </IconBase>
  );
}
